// @ts-nocheck

export const localeCodes =  [
  "en",
  "ru"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_company_45categories_46json_87f18688",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_booking_46json_2193f87f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_53ef51cf",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_company_45categories_46json_280aa04b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_booking_46json_c05d1efc",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ru_46json_7b4f6313",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/89c1b8e0" /* webpackChunkName: "config_i18n_46config_46ts_89c1b8e0" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ru",
    language: "ru",
    domains: [],
    defaultForDomains: []
  }
]

